<igo-measurer [store]="store" [map]="map" />
